import { FC, useState, useEffect } from 'react';
import { CustomEditor, ImageUpload, Input, SelectInput } from '../../../commons';
import { useCountries } from '../../../../hooks';

interface NewCategoryFormProps {
  values: any;
  setFieldValue: any;
}
const CategoryForm: FC<NewCategoryFormProps> = ({ values, setFieldValue }) => {
  const [initialValue, setInitialValue] = useState(values.description);
  const { countries, loading: countryLoading } = useCountries();

  const handleImageChange = (e: any) => {
    const file = e.target.files[0];
    setFieldValue('imageFile', file);

    const image = URL.createObjectURL(file);
    setFieldValue('imageCover', image);
  };

  useEffect(() => {
    setFieldValue('description', initialValue);
  }, [initialValue]);

  const countriesOptions = countries.map((country) => ({
    value: country.id,
    label: country.name,
  }));

  return (
    <div className='space-y-6'>
      <Input type='text' name='title' label='Category Title' />

      <div className='space-y-2'>
        <label className='block text-sm font-bold text-gray-700 dark:text-gray-300'>
          Category Description
        </label>
        <CustomEditor
          placeholder='Type category description here...'
          onChange={setInitialValue}
          value={initialValue}
          name='description'
        />
      </div>

      <div className='grid grid-cols-1 md:grid-cols-3 gap-6 items-start'>
        <div className='md:col-span-2'>
          <SelectInput
            name='country'
            label='Country'
            placeholder='Select Country'
            value={values.country}
            setFieldValue={setFieldValue}
            options={countriesOptions}
            isLoading={countryLoading}
          />
        </div>
        <div className='md:col-span-1'>
          <label className='block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2'>
            Category Image
          </label>
          <ImageUpload tourImage={values.imageCover} tourImageHandler={handleImageChange} />
        </div>
      </div>
    </div>
  );
};

export default CategoryForm;
